import React from "react";
import "./loadingIndicator.scss";

function LoadingIndicator() {
  return <div className="spinner"></div>;
}

export default LoadingIndicator;
